import React from "react";
import { Helmet } from "react-helmet";
import GalleryBody from "../components/gallery/GalleryBody";
import GreatHabibResults from "../components/reusables/GreatHabibResults";
import PageHero from "../components/reusables/hero/PageHero";

export default function Gallery() {
  return (
    <>
      <Helmet>
        <link rel="conanical" href="https://www.ghk9academy.com/gallery" />
        <meta name="description" content="Your Home of Trained Dogs" />
        <meta property="og:description" content="Your Home of Trained Dogs" />
        <meta
          property="og:title"
          content="Academy Gallery - Great Habib K9 Academy"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1703154000/banner_i6dkvh.jpg"
        />

        <meta
          name="twitter:title"
          content="Academy Gallery - Great Habib K9 Academy"
        />
        <meta
          name="twitter:text:title"
          content="Academy Gallery - Great Habib K9 Academy"
        />
        <meta name="twitter:description" content="Your Home of Trained Dogs" />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1703154000/banner_i6dkvh.jpg"
        />
        <title>Academy Gallery - Great Habib K9 Academy</title>
      </Helmet>
      <PageHero
        classes="doggy-bg"
        titleClasses="title uppercase yellow"
        title="Academy Gallery"
      />
      <GalleryBody />
      <GreatHabibResults />
    </>
  );
}
